module.exports = __webpack_public_path__ + "static/SocialDrop-1-light-24ca500c4daa4effcfc1c36e0c39df38.svg";